import { render, staticRenderFns } from "./EasypostInvoicesTableMobile.vue?vue&type=template&id=23cdbf2a&scoped=true"
import script from "./EasypostInvoicesTableMobile.vue?vue&type=script&lang=js"
export * from "./EasypostInvoicesTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cdbf2a",
  null
  
)

export default component.exports